// extracted by mini-css-extract-plugin
export default {"figureEatable":"Figure_figureEatable__Rr6Vh","absFigure":"Figure_absFigure__lmRd8","relFigure":"Figure_relFigure__EfOh8","dragging":"Figure_dragging__538a+"};